module.exports = __webpack_public_path__ + "img/thermometr-dark.854ad23d.svg";